import actions from './actions';

import initialState1 from '../../demoData/usersData.json';
import initialStateGroup from '../../demoData/usersGroupData.json';

const {
  GET_USER_LOAD,
  GET_USER_SUCCESS,
  GET_USER_ERROR,
  ADD_USER_BEGIN,
  ADD_USER_SUCCESS,
  ADD_USER_ERROR,
  GET_USER_ROLE_BEGIN,
  GET_USER_ROLE_SUCCESS,
  GET_USER_ROLE_ERROR,
  GET_USER_SINGLE__LOAD,
  GET_USER_SINGLE__SUCCESS,
  GET_USER_SINGLE__ERROR,
  GET_USER_CLEAR_OBJECT,
} = actions;

const userReducer = (state = initialState1) => {
  return state;
};

const userGroupReducer = (state = initialStateGroup) => {
  return state;
};

const initialState = {
  data: [],
  roles: [],
  loading: false,
  error: null,
  user: null,
};

const usersReducer = (state = initialState, action) => {
  const { type, users, err } = action;

  switch (type) {
    case GET_USER_LOAD:
      return { ...state, loading: true };

    case GET_USER_SUCCESS:
      return { ...state, data: users, error: false, loading: false };

    case GET_USER_ERROR:
      return { ...state, error: err, loading: false };

    case ADD_USER_BEGIN:
      return { ...state, loading: true };

    case ADD_USER_SUCCESS:
      return { ...state, data: users, loading: true, error: false };

    case ADD_USER_ERROR:
      return { ...state, error: err, loading: false };

    case GET_USER_ROLE_BEGIN:
      return { ...state, loading: true };

    case GET_USER_ROLE_SUCCESS:
      return { ...state, roles: users, error: false, loading: false };

    case GET_USER_ROLE_ERROR:
      return { ...state, error: err, loading: false };

    case GET_USER_SINGLE__LOAD:
      return { ...state, user: null, loading: true };

    case GET_USER_SINGLE__SUCCESS:
      return { ...state, user: users, error: false, loading: false };

    case GET_USER_SINGLE__ERROR:
      return { ...state, error: err, loading: false };

    case GET_USER_CLEAR_OBJECT:
      return { ...state, user: null, loading: false, error: false };

    default:
      return state;
  }
};

export { userReducer, userGroupReducer, usersReducer };
